import { fetchAllSubmodules } from "@/apis/config/configApi";
import DataTable from "@/common/elements/DataTable";
import { StyledReportContainer } from "@/components/CommonReport/styles";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const ReportList = ({
  results,
  selectBookingNumber,
  isLoading,
  pagination,
  setPagination,
  total,
  handleChangePagination,
  setSaveVisible,
  getReportListData,
}) => {
  const tableHeaders = [
    { key: "bookingNumber", text: "Booking Number" },
    { key: "name", text: "Full Name" },
    { key: "dob", text: "Date of Birth" },
    { key: "incarcerationDate", text: "Incarceration Date" },
    { key: "releaseDate", text: "Release Date" },
    { key: "destination", text: "Housing Location" },
    { key: "housingLocation", text: "Current Location" },
  ];
  const dispatch = useDispatch();
  const result = results?.map((res) => {
    return {
      ...res,
      name: `${res?.lastname || ""} ${res?.suffix || ""} ${
        res?.firstName || ""
      } ${res?.middleName || ""}`.trim(),
      destination: `${res?.housingAssignmentCell ? "Cell" : ""} ${
        res?.housingAssignmentBlock || ""
      } ${res?.housingAssignmentCell || ""} ${res?.housingAssignmentBed || ""}`,
    };
  });

  const handleRowClick = (data, index) => {
    if (data?.bookingNumber && index !== undefined && index !== null) {
      selectBookingNumber(data?.bookingNumber);
    }
  };

  useEffect(() => {
    // setLocalSubModules(selectOptions)
    dispatch(fetchAllSubmodules());
    setSaveVisible(false);
    // getReportListData();
  }, []);

  return (
    <StyledReportContainer>
      <DataTable
        rowUniqueId={"bookingNumber"}
        allowTableSorting={true}
        headers={tableHeaders}
        width="100%"
        className="table-striped"
        selectionColumnVisible={false}
        isAPiCallLoading={isLoading}
        data={result || []}
        onRowClick={handleRowClick}
        pagination={pagination}
        setPagination={setPagination}
        totalRecords={total}
        onPageChange={handleChangePagination}
      />
    </StyledReportContainer>
  );
};

export default ReportList;
